/**
 * ChannelsCtrl controller
 * Show all channels
 */

import { PLATFORM_TYPES } from 'app/core/constants'
import { getName, keyValue } from 'app/helpers/entity'
import { nbspify } from 'app/helpers/string'

// controller mixins
ChannelsCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * ChannelsCtrl controller
 *
 * @class ChannelsCtrl
 * @memberof mwApp/channels
 * @see mwApp/channels
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/channels.controller:ChannelsCtrl
 */
/* @ngInject */
export default function ChannelsCtrl ($scope, $transition$, $location, ChannelDTO, Extension, Network, UrlPolicy, authSvc) {
  var vm = this

  vm.onScrollUrlPolicies = UrlPolicy.getPolicies(vm.urlPolicies = [], true)
  vm.getUrlPoliciesForStSelect = function (select) {
    select.open && vm.onScrollUrlPolicies(undefined, { q: select.search })
  }

  // get token generator id from extension
  const { tokenGeneratorId, tokenGeneratorName } = $location.search()
  vm.streamPolicyId = $location.search().streamPolicyId

  vm.isFound = true
  vm.ChannelType = 'TV' // 'Radio' | 'TV'
  vm.platforms = PLATFORM_TYPES.filter((p) => {
    return !(!authSvc.hasEnabledFlag('WEB_PLATFORM_ENABLED') && p.name === 'WEB')
  }).map(getName) // platforms
  vm.tokenGeneratorName = tokenGeneratorName

  // get packages and languages
  ChannelDTO.loadExtra({ params: { type: vm.ChannelType } })
    .then(
      data => {
        vm.languages = data.languages
        vm.packages = data.networks.map(keyValue())
      }
    )

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true

  /**
   * Channels list
   *
   * @memberof mwApp/channels.controller:ChannelsCtrl
   * @type {models.ChannelDTO[]}
   */
  vm.channels = []

  /**
   * Get Channels from backend
   *
   * @memberof mwApp/channels.controller:ChannelsCtrl
   * @param {Object} tableState - smart table state object
   */
  vm.getChannels = function (tableState) {
    // set default sort by channelNumber
    if (!tableState.sort.predicate) {
      tableState.sort.predicate = 'channelNumber'
      tableState.sort.reverse = false
    }

    var pObject = tableState.search.predicateObject = tableState.search.predicateObject || {}

    // add filter by channel type
    pObject.type = vm.ChannelType

    // add filter by token generator
    if (tokenGeneratorId) {
      pObject.tokenGeneratorId = tokenGeneratorId
    }

    // add filter by streamPolicyId
    if (vm.streamPolicyId) {
      pObject.streamPolicyId = vm.streamPolicyId
      vm.streamPolicyId = null
    }

    ChannelDTO.loadSmart(tableState)
      .then(
        data => {
          vm.channels = data.content
          vm.isFound = !!vm.channels.length
          $scope.loading = false
        }
      )
  }

  vm.tokenFormatter = function (str) {
    return nbspify(str)
  }

  /**
   * Delete channel
   *
   * @memberof mwApp/channels.controller:ChannelsCtrl
   * @param {models.ChannelDTO} ch
   */
  vm.delete = function (ch) {
    ch._delete()
      .then(() => $scope.$broadcast('refreshTable'))
  }

  $scope.$watch('vm.ChannelType', (n, o) => {
    if (o && n && o !== n) {
      vm.getChannels({ sort: {}, search: {}, pagination: { number: 25 } })
    }
  })
}
